class ImportSuccessModalCtrl {
  static bindings = {
    modalScope: '<',
    modalPromise: '<',
    uploadApi: '<',
    errorButtonText: '<',
    continueButtonText: '<'
  };

  modalScope;
  modalPromise;
  uploadApi;
  errorButtonText;
  continueButtonText;

  state;

  unsubscribeFromStore;

  constructor(private $scope, private UploadModel) {
    'ngInject';
  }

  $onInit() {
    this.state = this.UploadModel.store.getState();

    this.unsubscribeFromStore = this.UploadModel.store.subscribe(() => {
      // Update angularjs if the state is changed via redux debugger
      // this.$scope.$applyAsync(() => {
      this.state = this.UploadModel.store.getState();
      // });
    });
  }

  get importMatchedCount() {
    if (this.state && this.state.searchResults) {
      return this.state.searchResults.recordMatchedCount;
    } else {
      return 'N/A';
    }
  }

  $onDestroy() {
    this.unsubscribeFromStore();
  }

  getDownloadUrl() {
    if (this.state && this.state.searchResults) {
      return `${this.uploadApi.appRoot}/api${this.state.searchResults.downloadUrl}`;
    } else {
      return '';
    }
  }

  close() {
    this.modalScope.$hide();
    this.modalPromise.resolve();
  }
}

export const ImportSuccessModalComponent = {
  template: require('./importSuccessModal.component.html'),
  controller: ImportSuccessModalCtrl,
  bindings: ImportSuccessModalCtrl.bindings,
  transclude: {
    importingDescription: '?importingDescription'
  }
};
